module.exports = __webpack_public_path__ + "img/banner_zhTc.c47b1578.png";